"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAMESPACE = exports.Schema = exports.Registry = exports.OtaJob = exports.OtaGroup = exports.OtaBuild = exports.Job = exports.Data = exports.CommandJob = exports.Command = void 0;
exports.Command = __importStar(require("./command"));
exports.CommandJob = __importStar(require("./command-job"));
exports.Data = __importStar(require("./data"));
exports.Job = __importStar(require("./job"));
exports.OtaBuild = __importStar(require("./ota-build"));
exports.OtaGroup = __importStar(require("./ota-group"));
exports.OtaJob = __importStar(require("./ota-job"));
exports.Registry = __importStar(require("./registry"));
exports.Schema = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Device';
//# sourceMappingURL=index.js.map